import axios from "axios";
import { config } from "../configs";
import { getSessionToken } from "./getToken";
// Get userOrgs
// import { getUserOrgs } from "./org";
// import { maintenanceplans } from "../__mocks__";
import { getUserOrgs } from "./org";
const createMaintenancePlans = async (attributes, orgId) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/maintenanceplans`;
      const { data } = await axios({
        method: "POST",
        headers: {
          Authorization: jwtToken,
          Application: "Platform", 
          Organization: orgId,
        },
        url: URL,
        data: attributes,
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

const createGroup = async (orgId, attributes, planId) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/maintenanceplans/${planId}/groups`;
      const { data } = await axios({
        method: "POST",
        headers: {
          Authorization: jwtToken,
          Application: "Platform", 
          Organization: orgId,
        },
        url: URL,
        data: attributes,
      });
      resolve(data);
    } catch (error) {
      console.log(error.message);
      reject(error);
    }
  });
};

const updateGroup = async (orgId, attributes, planId, groupId) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/maintenanceplans/${planId}/groups/${groupId}`;
      const { data } = await axios({
        method: "PATCH",
        headers: {
          Authorization: jwtToken,
          Application: "Platform", 
          Organization: orgId,
        },
        url: URL,
        data: attributes,
      });
      resolve(data);
    } catch (error) {
      console.log(error.message);
      reject(error);
    }
  });
};

const deleteGroup = async (orgId, planId, groupId) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/maintenanceplans/${planId}/groups/${groupId}`;
      const { data } = await axios({
        method: "DELETE",
        headers: {
          Authorization: jwtToken,
          Application: "Platform", 
          Organization: orgId,
        },
        url: URL,
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

const createItem = async (orgId, attributes, planId, groupId) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/maintenanceplans/${planId}/groups/${groupId}/serviceitems`;
      // console.log(URL);
      const { data } = await axios({
        method: "POST",
        headers: {
          Authorization: jwtToken,
          Application: "Platform", 
          Organization: orgId,
        },
        url: URL,
        data: attributes,
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

const updateItem = async (orgId, attributes, planId, groupId, itemId) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/maintenanceplans/${planId}/groups/${groupId}/serviceitems/${itemId}`;
      // console.log(URL);
      const { data } = await axios({
        method: "PATCH",
        headers: {
          Authorization: jwtToken,
          Application: "Platform", 
          Organization: orgId,
        },
        url: URL,
        data: attributes,
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

const deleteItem = async (orgId, planId, groupId, itemId) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/maintenanceplans/${planId}/groups/${groupId}/serviceitems/${itemId}`;
      const { data } = await axios({
        method: "DELETE",
        headers: {
          Authorization: jwtToken,
          Application: "Platform", 
          Organization: orgId,
        },
        url: URL,
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

const getMaintenancePlan = async (orgId, id) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/maintenanceplans/${id}?all=true`;
      const { data } = await axios({
        method: "GET",
        headers: {
          Authorization: jwtToken,
          Application: "Platform", 
          Organization: orgId,
        },
        url: URL,
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

const updateMaintenancePlan = async (orgId, orgData, id) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/maintenanceplans/${id}`;
      const { data } = await axios({
        method: "PATCH",
        headers: {
          Authorization: jwtToken,
          Application: "Platform", 
          Organization: orgId,
        },
        url: URL,
        data: orgData,
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

const deleteMaintenancePlan = async (orgId, id) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/maintenanceplans/${id}`;
      const { data } = await axios({
        method: "DELETE",
        headers: {
          Authorization: jwtToken,
          Application: "Platform", 
          Organization: orgId,
        },
        url: URL,
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

const getOrgMaintenancePlan = async (
  orgs,
  index = 0,
  maintenancePlans = []
) => {
  return new Promise(async function (resolve, reject) {
    try {
      if (orgs.length === 0) {
        resolve([]);
      } else {
        const jwtToken = await getSessionToken();
        const URL = `${config.baseURL}/maintenanceplans`;
        const { data } = await axios({
          method: "GET",
          headers: {
            Authorization: jwtToken,
            Application: "Platform", 
            organization: orgs[index]?.id,
          },
          url: URL,
        });
        // to be done from API
        let newData = data.map((item) => ({
          ...item,
          orgId: orgs[index]?.id,
          orgName: orgs[index]?.name,
        }));
        maintenancePlans = [...maintenancePlans, ...newData];
        if (index >= Array.from(orgs).length - 1)
          return resolve(maintenancePlans);
        return resolve(
          await getOrgMaintenancePlan(orgs, index + 1, maintenancePlans)
        );
      }
    } catch (error) {
      reject(error);
    }
  });
};

const getMaintenancePlans = async () => {
  return new Promise(async function (resolve, reject) {
    try {
      let orgs = await getUserOrgs();
      let maintenancePlans = await getOrgMaintenancePlan(orgs);
      resolve(maintenancePlans);
    } catch (error) {
      reject(error);
    }
  });
};

export {
  createMaintenancePlans,
  getMaintenancePlans,
  getMaintenancePlan,
  updateMaintenancePlan,
  createGroup,
  createItem,
  updateGroup,
  updateItem,
  deleteGroup,
  deleteItem,
  deleteMaintenancePlan,
};
